import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserAtividade } from './user-atividade.model';
import { catchError, Observable, of, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';


@Injectable({
  providedIn: 'root'
})
export class UserAtividadeService {

  constructor(private http: HttpClient, private authService: AuthService) { }

  urlUserActivity: string = environment.apiBaseURL + '/Mdc/UserActivity'
  userAtividade: UserAtividade[] = [];

  getUserActivity(email: string): Observable<UserAtividade[]> {
    return this.http.post<UserAtividade[]>(this.urlUserActivity, { email: email }).pipe(
      tap(res => {
        this.userAtividade = res as UserAtividade[];
      }),
      catchError(err => {
        if (err.status === 401) {
          this.authService.showSessionExpiredAlert();
        }
        console.error(err)
        return of([]);
      })
    );
  }
}
